<div class="overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm">
  <table class="w-full table-fixed border-collapse">
    <thead class="border-b border-gray-100 bg-gray-50/50">
      <tr>
        <th class="w-12 px-6 py-4 text-start text-xs font-bold text-gray-400 uppercase" i18n="@@attr.col.number">#</th>
        <th class="w-44 px-6 py-4 text-start text-xs font-bold text-gray-400 uppercase" i18n="@@attr.col.attribute">
          Attribute
        </th>
        <th class="px-6 py-4 text-start text-xs font-bold text-gray-400 uppercase" i18n="@@attr.col.values">Values</th>
        <th class="w-24 px-6 py-4 text-center text-xs font-bold text-gray-400 uppercase"></th>
      </tr>
    </thead>
    <tbody class="divide-y divide-gray-50 bg-white" cdkDropList (cdkDropListDropped)="handleDrop($event)">
      @for (attr of attributes(); track attr.attributeKey.id || i; let i = $index) {
        <tr class="cursor-move bg-white transition-colors hover:bg-gray-50/30" cdkDrag>
          <td class="px-6 py-4 text-center font-medium text-gray-400">
            <div class="flex items-center justify-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="shrink-0 text-gray-300">
                <circle cx="9" cy="5" r="1.5" />
                <circle cx="15" cy="5" r="1.5" />
                <circle cx="9" cy="12" r="1.5" />
                <circle cx="15" cy="12" r="1.5" />
                <circle cx="9" cy="19" r="1.5" />
                <circle cx="15" cy="19" r="1.5" />
              </svg>
              {{ i + 1 }}
            </div>
          </td>

          <td class="px-6 py-4">
            <div class="flex flex-col">
              <span
                class="truncate font-bold text-gray-800"
                [ngClass]="productType() === 'edit' ? 'font-medium' : 'font-bold'"
                [title]="getAttrTitle(attr)">
                {{ getAttrTitle(attr) }}
              </span>
              @if (attr.isGlobal) {
                <span
                  class="text-primary mt-0.5 text-[10px] font-extrabold tracking-widest uppercase"
                  i18n="@@attr.badge.global">
                  Global
                </span>
              }
            </div>
          </td>

          <td class="px-6 py-4">
            <div class="flex flex-wrap items-center gap-2">
              @for (val of attr.attributeValues; track val.id || vIdx; let vIdx = $index) {
                <span
                  class="text-primary flex max-w-[140px] items-center gap-2 rounded-full border border-red-100 bg-red-50 px-3 py-1.5 text-[11px] font-bold"
                  [ngClass]="productType() === 'edit' ? 'font-medium' : 'font-bold'">
                  <span class="truncate" [title]="getValTitle(val)">
                    {{ getValTitle(val) }}
                  </span>
                  @if (!attr.isGlobal) {
                    <div class="ms-1 flex shrink-0 items-center gap-1.5 border-s border-red-200 ps-1.5">
                      <svg
                        (click)="onEditValue.emit({ attrIdx: i, valIdx: vIdx })"
                        class="cursor-pointer hover:text-black"
                        width="11"
                        height="11"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                      </svg>
                      <svg
                        (click)="onDeleteValue.emit({ attrIdx: i, valIdx: vIdx })"
                        class="cursor-pointer hover:text-black"
                        width="11"
                        height="11"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                      </svg>
                    </div>
                  }
                </span>
              }
              @if (!attr.isGlobal) {
                <button (click)="onAddValue.emit(i)" class="hover-text-primary text-gray-300">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                  </svg>
                </button>
              }
            </div>
          </td>

          <td class="px-6 py-4">
            <div class="flex items-center justify-center gap-3">
              @if (!attr.isGlobal) {
                <button (click)="onEditAttr.emit(i)" class="text-gray-300 hover:text-gray-600">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path d="M12 20h9" />
                    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
                  </svg>
                </button>
              }
              <button (click)="onRemove.emit(i)" class="text-gray-300 hover:text-red-600">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                  <polyline points="3 6 5 6 21 6" />
                  <path d="M19 6l-1 14H6L5 6" />
                  <path d="M10 11v6" />
                  <path d="M14 11v6" />
                  <path d="M9 6V4h6v2" />
                </svg>
              </button>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
